import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

const PublicOnlyRoute = ({ children }) => {
    const { currentUser } = useAuth();

    if (currentUser) {
        const isAdminOrStaff = ['admin', 'staff'].includes((currentUser.role || '').toLowerCase());
        // Redirect based on role
        return <Navigate to={isAdminOrStaff ? '/admin' : '/home'} replace />;
    }

    return children;
};

export default PublicOnlyRoute;
